import React from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest, msalConfig } from "../authConfig";
import Button from "react-bootstrap/Button";
import {
  PublicClientApplication,
  //InteractionRequiredAuthError,
} from "@azure/msal-browser";
import { useNavigate } from "react-router-dom";

const msalClient = new PublicClientApplication(msalConfig);

export const SignInButton = () => {
  const { instance } = useMsal();

  const navigate = useNavigate();
  async function handleLogin(instance) {
    await msalClient.initialize();
    const authResult = await msalClient.loginPopup(loginRequest);
    sessionStorage.setItem("msalAccount", authResult.account.username);
    //   const account = sessionStorage.getItem("msalAccount");
    console.log("authResult", authResult);
    if (authResult) {
      fetch("https://aquta-mongo-api.azurewebsites.net/savetenant", {
        method: "POST",
        body: JSON.stringify(authResult),
      })
        .then((res) => {
          console.log("Request complete! response:", res);

          navigate("/response", {
            state: { res: true },
          });
          //alert("Operation completed successfully.");
        })
        .catch((err) => {
          navigate("/response", { state: { res: true } });
        });
    }
  }

  return (
    <Button
      variant="outline-primary"
      className="ml-auto"
      onClick={() => handleLogin(instance)}
    >
      Authorize
    </Button>
  );
};
